module.exports = __webpack_public_path__ + "img/3.f8d36d4.jpg";